module.exports = __webpack_public_path__ + "img/allow-screen-share.0d4e634b.jpg";